export const candidateProfileStateKeys = {
  isLoading: 'isLoading',
  isSubmitting: 'isSubmitting',
  profileSectionsStatesIsLoading: 'profileSectionsStatesIsLoading',
  biographicalInformation: 'biographicalInformation',
  profileSectionsStates: 'profileSectionsStates',
  housingPreferences: 'housingPreferences',
  health: 'health',
  languages: 'languages',
  sportActivities: 'sportActivities',
  personal: 'personal',
  secondarySchools: 'secondarySchools',
  teachingExperience: 'teachingExperience',
  contactInformation: 'contactInformation',
  universitiesColleges: 'universitiesColleges',
  teachingCredentials: 'teachingCredentials'
};

export const validationConstants = {
  biographicalInformationMaxLength: 3500,
  biographicalInformationMinLength: 100,
  internSportsMaxLength: 511,
  internActivitiesMaxLength: 511,
  healthRelatedInfoMaxLength: 500,
  minTotalSickDays: 0,
  maxTotalSickDays: 100,
  petsMaxLength: 500,
  otherTeachingCredentialSubjectsMaxLength: 255,
  minYearsOverseas: 0,
  maxYearsOverseas: 45,
  cityMaxLength: 50,
  stateMaxLength: 50,
  addressLineMaxLength: 127,
  experienceCompanyNameMaxLength: 255,
  experienceSupervisorNameMaxLength: 50,
  experienceSupervisorEmailMaxLength: 100,
  experienceSupervisorPhoneMaxLength: 50,
  experienceSupervisorJobTitleMaxLength: 50,
  experiencePositionNameMaxLength: 255,
  experienceMinYear: 1960,
  experienceMaxYearAllowance: 5,
  additionalAddressMinYear: 1950,
  additionalAddressMaxYearAllowance: 0,
  minYearsOfExperience: 0,
  maxYearsOfExperience: 45,
  minMonthsOfExperience: 0,
  maxMonthsOfExperience: 48,
  partnerLastNameMaxLength: 63,
  partnerFirstNameMaxLength: 63,
  partnerMiddleNameMaxLength: 63,
  minNumberOfChildren: 0,
  maxNumberOfChildren: 10,
  firstNameMaxLength: 63,
  middleNameMaxLength: 63,
  lastNameMaxLength: 63,
  maxUntypedDocumentsCount: 3,
  phoneNumberMaxLength: 63,
  skypeMaxLength: 100,
  higherEducationDegreeMaxLength: 500,
  higherEducationNameMaxLength: 500,
  higherEducationFieldOfStudyMaxLength: 500,
  higherEducationLocationMaxLength: 500,
  higherEducationMinYear: 1950,
  higherEducationMaxYearAllowance: 5,
  secondarySchoolNameMaxLength: 500,
  secondarySchoolLocationMaxLength: 500,
  secondarySchoolMinYear: 1950,
  secondarySchoolMaxYearAllowance: 5,
  teachingCredentialAwardedByMaxLength: 255,
  documentDescriptionMaxLength: 50,
  experienceInternAgeRangeMaxLength: 100
};



// WEBPACK FOOTER //
// ./src/constants/candidate-profile.js